import axiosInstance from './../axiosInstance';
import moment from 'moment';

/**
 * @name getEvents
 * @desc Get events.
 * @return array
 */
export const getEvents = (userID, params = {}) => {
  return axiosInstance.get(`users/${userID}/partnerEvents`, {
    params: params
  });
};


/**
 * @name getEvent
 * @desc Get event.
 * @param {string} eventID
 * @return object
 */
export const getEvent = (eventID, partnerID) => {
  return axiosInstance.get(`events/${eventID}`);
};

/**
 * @name getEvent
 * @desc Get event.
 * @param {string} eventID
 * @return object
 */
export const getPartnerPortalSettings = (eventID, partnerID) => {
  return axiosInstance.get(`events/${eventID}/partnerPortals`);
};


/**
 * @name getUpcomingEvents
 * @desc Get events that are upcoming.
 * @params {object} params
 * @return array
 */
export const getUpcomingEvents = (userID, params) => {
  const filter = [{
      column: 'eventEnds',
      condition: 'greater_than',
      values: [moment().subtract(1, 'days').format()]
  }];
  return getEvents(userID, { filter, ...params });
}
